import React, {useState} from 'react';

function Contact() {
  const [isSuccess, setIsSuccess] = useState(false);
  const onSubmit = async (event) => {
  event.preventDefault();
  
  const formData = new FormData(event.target);
  formData.append("access_key", "9c238dbe-a5d3-438f-9ad7-481948efc7d3");

  try {
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setIsSuccess(true);
      event.target.reset(); // Vyčistí formulář po úspěchu
    } else {
      setIsSuccess(false);
      console.error("Web3Forms error:", data);
    }
  } catch (error) {
    setIsSuccess(false);
    console.error("Network error:", error);
  }
};


  return (
    <section className="contact section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 valign">
            <div className="sec-head info-box full-width md-mb80">
              
              <div className="phone fz-30 fw-600 underline main-color">
                <a href="#0">+420 604 286 149</a>
              </div>
              <div className="morinfo mt-50 pb-30 bord-thin-bottom">
                <h6 className="mb-15">Address</h6>
                <p>Bohuslava Martinů 814/7, Ostrava-Poruba</p>
              </div>
              <div className="morinfo mt-30 pb-30 bord-thin-bottom">
                <h6 className="mb-15">Email</h6>
                <p>info@zonyatech.com</p>
              </div>

              <div className="social-icon mt-50">                
                <a href="mailto:info@zonyatech.com">
                  <i className="fas fa-at"></i>
                </a>
                <a href="https://www.instagram.com/zonya_tech/" target='_blank'>
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="tel:+420604286149">
                  <i className="fas fa-phone"></i>
                </a>
              </div>
            </div>
          </div>
          {isSuccess ? (
            <div className="col-lg-7 offset-lg-1 valign">
              <div className="full-width text-center">
                <div className="sec-head mb-50">
                  {/* Ikona nebo animace */}
                  <div className="icon main-color mb-30">
                    <i className="fas fa-paper-plane fa-3x"></i> 
                  </div>
                  <h3 className="text-u">
                    Thank <span className="fw-200">You!</span>
                  </h3>
                  <p className="mt-15">Your message has been successfully sent. <br/> We will contact you soon.</p>
                  <div className="mt-30">
                    {/* <button 
                      onClick={() => setIsSent(false)} 
                      className="butn butn-bord radius-30"
                    >
                      <span className="text">Send another?</span>
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-lg-7 offset-lg-1 valign">
              <div className="full-width">
                <div className="sec-head mb-50">
                  <h6 className="sub-title main-color mb-15">Let&lsquo;s Chat</h6>
                  <h3 className="text-u ls1">
                    Send a <span className="fw-200">message</span>
                  </h3>
                </div>
                <form 
                  onSubmit={onSubmit}
                  id="contact-form"
                  className="form2"
                  method="post"
                  action="contact.php"
                >
                  <div className="messages"></div>

                  <div className="controls row">
                    <div className="col-lg-6">
                      <div className="form-group mb-30">
                        <input
                          id="form_name"
                          type="text"
                          name="name"
                          placeholder="Name"
                          required="required"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group mb-30">
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          placeholder="Email"
                          required="required"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group mb-30">
                        <input
                          id="form_subject"
                          type="text"
                          name="subject"
                          placeholder="Subject"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          id="form_message"
                          name="message"
                          placeholder="Message"
                          rows="4"
                          required="required"
                        ></textarea>
                      </div>
                      <div className="mt-30">
                        <button
                          type="submit"
                          className="butn butn-full butn-bord radius-30"
                        >
                          <span className="text">Let&lsquo;s Talk</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Contact;
